import axios from 'axios';

export default class DealerFind {
    constructor() {
        this.section = document.querySelector('.block-dealer-find');

        this.stateSelect = this.section.querySelector('#estado');
        this.citiesBlock = this.section.querySelector('.citiesBlock');
        this.citySelect = this.citiesBlock.querySelector('#cidade');
        this.dataBlock = this.section.querySelector('.dataBlock');

        this.init();
        this.preselectFromQuery();
    }

    init() {
        if (this.stateSelect && this.citySelect) {
            // Change no estado → busca cidades
            this.stateSelect.addEventListener('change', (e) => {
                const stateId = e.target.value;
                if (stateId) {
                    this.dataBlock.classList.remove('active');
                    this.citiesBlock.classList.remove('active');
                    this.getCities(stateId);
                } else {
                    this.citySelect.innerHTML = `<option value="">Selecione uma cidade</option>`;
                    this.dataBlock.innerHTML = ``;
                    this.dataBlock.classList.remove('active');
                }

                this.updateQueryString(stateId, null); // Atualiza query string só com estado
            });

            // Change na cidade → busca dados
            this.citySelect.addEventListener('change', (e) => {
                const cityId = e.target.value;
                const stateId = this.stateSelect.value;

                if (cityId) {
                    this.getData(stateId, cityId);
                } else if (stateId) {
                    this.getData(stateId, null); // só o estado selecionado
                } else {
                    this.dataBlock.innerHTML = ``;
                    this.dataBlock.classList.remove('active');
                }

                this.updateQueryString(stateId, cityId); // Atualiza query string com estado + cidade
            });
        }
    }

    async getCities(stateId) {
        try {
            this.citySelect.innerHTML = `<option value="">Carregando...</option>`;

            const response = await axios.get(`/dealers/cidades/${stateId}`);
            const cidades = response.data;

            this.citySelect.innerHTML = `<option value="">Selecione uma cidade</option>`;

            Object.entries(cidades).forEach(([nome, id]) => {
                const opt = document.createElement('option');
                opt.value = id;
                opt.textContent = nome;
                this.citySelect.appendChild(opt);
            });

            this.citiesBlock.classList.add('active');
        } catch (error) {
            console.error('Erro ao carregar cidades:', error);
            this.citySelect.innerHTML = `<option value="">Erro ao carregar</option>`;
        }
    }

    async getData(stateId = null, cityId = null) {
        try {
            this.dataBlock.innerHTML = `<p>Carregando dados...</p>`;

            const url = `/dealers/fetch/${stateId || ''}/${cityId || ''}`;
            const response = await axios.get(url);

            const { html } = response.data;

            if (!html || typeof html !== 'string' || html.trim().length === 0) {
                this.dataBlock.innerHTML = `<p class="font-bold text-base/150">Nenhum resultado encontrado.</p>`;
                this.dataBlock.classList.add('active');
                return;
            }

            this.dataBlock.innerHTML = html;
            this.dataBlock.classList.add('active');

        } catch (error) {
            console.error('Erro ao carregar dados:', error);
            this.dataBlock.innerHTML = `<p>Erro ao carregar dados.</p>`;
        }
    }


    // Atualiza a query string do navegador sem recarregar
    static slugify(text) {
        return text
            .normalize('NFD')                // separa acentos
            .replace(/[\u0300-\u036f]/g, '') // remove acentos
            .replace(/\s+/g, '-')            // substitui espaços por -
            .replace(/[^a-zA-Z0-9-]/g, '')  // remove caracteres especiais
            .toLowerCase();                  // opcional: deixa tudo minúsculo
    }

    updateQueryString(stateId = null, cityId = null) {
        const params = new URLSearchParams();

        const stateName = stateId ? this.stateSelect.options[this.stateSelect.selectedIndex].text : null;
        const cityName = cityId ? this.citySelect.options[this.citySelect.selectedIndex].text : null;

        if (stateName) params.set('estado', DealerFind.slugify(stateName));
        if (cityName) params.set('cidade', DealerFind.slugify(cityName));

        const newUrl = `${window.location.pathname}?${params.toString()}`;
        history.pushState({}, '', newUrl);
    }

    // Pré-seleciona estado e cidade se houver query string
    preselectFromQuery() {
        const params = new URLSearchParams(window.location.search);
        const stateSlug = params.get('estado');
        const citySlug = params.get('cidade');

        if (!stateSlug) return;

        // Encontra a opção do estado pelo slug
        const stateOption = Array.from(this.stateSelect.options).find(
            opt => DealerFind.slugify(opt.text) === stateSlug
        );

        if (stateOption) {
            this.stateSelect.value = stateOption.value;
            this.getCities(stateOption.value).then(() => {
                if (citySlug) {
                    // Encontra a opção da cidade pelo slug
                    const cityOption = Array.from(this.citySelect.options).find(
                        opt => DealerFind.slugify(opt.text) === citySlug
                    );
                    if (cityOption) {
                        this.citySelect.value = cityOption.value;
                        this.getData(stateOption.value, cityOption.value);
                    } else {
                        this.getData(stateOption.value, null);
                    }
                } else {
                    this.getData(stateOption.value, null);
                }
            });
        }
    }


}

// Inicializa se a seção existir
if (document.querySelector('.block-dealer-find')) {
    new DealerFind();
}
